import { IconButton } from '@starryui10/Buttons/IconButton';
import { CloseThick } from '@starryui10/images/icons/CloseThick';
import { ReactPortal } from '@starryui10/layouts/ReactPortal';
import { HStack, VStack } from '@starryui10/layouts/Stack';
import { color } from '@starryui10/theme/color';
import Text from '@starryui10/typography/Text';
import * as React from 'react';
import styled from 'styled-components';

interface IModalProps {
    footer: React.ReactNode;
    variant?: 'Medium';
    title: string;
    height?: string;
    onClose: () => void;
}

export const Modal: React.FC<IModalProps> = ({ footer, title, children, height = '90vh', onClose }) => {
    return (
        <ReactPortal>
            <ModalDiv>
                <Dialog open height={height} role="dialog" tabIndex={0}>
                    <VStack align="start" height="100%" rows="55px 1fr 55px">
                        <Header>
                            <HStack pad={['none', 'medium']} height="100%" columns="1fr max-content">
                                <Text color={color.Grey.G80} variant="large.bold">
                                    {title}
                                </Text>
                                <IconButton ariaLabel="Close Dialog" title="Close Dialog" onClick={onClose}>
                                    <CloseThick />
                                </IconButton>
                            </HStack>
                        </Header>

                        <Article>{children}</Article>

                        <Footer>
                            <HStack pad={['none', 'medium']} height="100%">
                                {footer}
                            </HStack>
                        </Footer>
                    </VStack>
                </Dialog>
            </ModalDiv>
        </ReactPortal>
    );
};

const ModalDiv = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(50, 55, 61, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

const Dialog = styled.dialog<{ height: string }>`
    width: 784px;
    height: ${(props) => props.height};
    background: white;
    border: 0;
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.07);
    border-radius: 6px;
    padding: 0;
`;

const Header = styled.header`
    min-height: 55px;
    height: 55px;
    border-bottom: 1px solid ${color.Grey.G20};
`;

const Article = styled.article`
    overflow: auto;
    height: 100%;
`;

const Footer = styled.footer`
    border-top: 1px solid ${color.Grey.G20};
    min-height: 55px;
    height: 55px;
`;
